export function tryParse(target) {
  let result;

  try {
    result = JSON.parse(target);
  } catch(ex) {
    result = target;
  }

  return result;
}

export function tryStringify(target) {
  let result;

  try {
    result = JSON.stringify(target);
  } catch(ex) {
    result = target;
  }

  return result;
}




// WEBPACK FOOTER //
// ../x/packages/util/src/json.js